import { render, staticRenderFns } from "./SiteFooter.vue?vue&type=template&id=71010658&scoped=true"
var script = {}
import style0 from "./SiteFooter.vue?vue&type=style&index=0&id=71010658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71010658",
  null
  
)

export default component.exports